import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import theme from './theme';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import FloatingButtons from './components/FloatingButtons';
import HomePage from './pages/HomePage';
import SearchResults from './pages/SearchResults';
import RoomDetails from './pages/RoomDetails';
import Reservation from './pages/Reservation';
import ThankYou from './pages/ThankYou';
import Payment from './pages/Payment';
import Contact from './pages/Contact';
import Rooms from './pages/Rooms';
import AboutUs from './pages/AboutUs';
import FoodAndDrink from './pages/FoodAndDrink';
import Shopping from './pages/Shopping';
import PlymouthHighlights from './pages/PlymouthHighlights';
import NearbyAttractions from './pages/NearbyAttractions';
import RulesAndRegulation from './pages/RulesAndRegulation';
import GettingToHotel from './pages/GettingToHotel';
import GalleryDynamic from './pages/GalleryDynamic';
import RestaurantDynamic from './pages/RestaurantDynamic';
import BlogsDynamic from './pages/BlogsDynamic';
import BlogDetailsDynamic from './pages/BlogDetailsDynamic';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <div style={{ minHeight: '100vh', backgroundColor: '#f8fafc' }}>
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/search" element={<SearchResults />} />
              <Route path="/room/:id" element={<RoomDetails />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/food-and-drink" element={<FoodAndDrink />} />
              <Route path="/shopping" element={<Shopping />} />
              <Route path="/plymouth-highlights" element={<PlymouthHighlights />} />
              <Route path="/nearby-attractions" element={<NearbyAttractions />} />
              <Route path="/rules-and-regulation" element={<RulesAndRegulation />} />
              <Route path="/getting-to-the-grosvenor-hotel-plymouth" element={<GettingToHotel />} />
              <Route path="/reservation" element={<Reservation />} />
              <Route path="/payment" element={<Payment />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="/reservation/thankyou" element={<ThankYou />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/rooms" element={<Rooms />} />
              <Route path="/gallery" element={<GalleryDynamic />} />
              <Route path="/restaurant" element={<RestaurantDynamic />} />
              <Route path="/blogs" element={<BlogsDynamic />} />
              <Route path="/blog/:slug" element={<BlogDetailsDynamic />} />
            </Routes>
          </main>
          <Footer />
          <FloatingButtons />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
